import get from 'lodash.get';
import { useEffect, useState } from 'react';

import getDefaultCountryCode from 'utils/getDefaultCountryCode';

const useDefaultConfig = ({ errors, defaultValue, name }) => {
  const [locale, setLocale] = useState([]);
  const [stylesLoaded, setStylesLoaded] = useState(false);

  const defaultCountry = getDefaultCountryCode();
  const error = get(errors, name, false);

  useEffect(() => {
    import('react-phone-input-2/lib/style.css').then(() => {
      setStylesLoaded(true);
    });

    try {
      const lang = require(`react-phone-input-2/lang/${defaultCountry}.json`);
      setLocale(lang);
    } catch {
      console.error(`No lang file for ${defaultCountry}`);
    }
  }, []);

  // From the API we get phone number with "+" at the beginning
  // validation and "react-phone-input-2" require phone number without "+"
  const inputDefaultValue = defaultValue?.replace('+', '');

  return {
    stylesLoaded,
    defaultCountry,
    error,
    inputDefaultValue,
    locale,
  };
};

export default useDefaultConfig;
